module.exports = __webpack_public_path__ + "img/vol03_cup01_badge.f38ce267.png";